export const languageCode = {
    ENGLISH: 'en',
    GERMANY: 'de',
    HUNGARIAN: 'hu',
    PORTUGAL: 'pt',
};
